import axios from "axios";
import type {
  OrderStatusesResponseProto,
  OrderStatusProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/patient_prescription_service";

import { HEALTHCARE_API } from "@modules/common/constants";

export type { OrderStatusProto };

export const getPrescriptionOrders = async (
  accessCode: string,
  accessToken: string
): Promise<OrderStatusProto[]> => {
  const response = await axios.get<OrderStatusesResponseProto>(
    `${HEALTHCARE_API}/patient/${accessCode}/prescription_orders`,
    {
      headers: {
        Authorization: `bearer ${accessToken}`,
      },
    }
  );
  return response.data.statuses ?? [];
};
